const bosses = [
  {
    img: 'Jupiter',
    name: '尤比太',
    hard: '劇情\n任務|普通|困難',
    level: '295|295|295',
    health: '6.93兆|1.0266京|4.94京',
    defense: '380|380|380',
    ARCAUT: 'AUT 200|AUT 810|AUT 810',
    timeout: '30|30|30',
    death: '破裂1000|破裂1000|破裂1000',
    other: '|尤比太機器人|尤比太機器人',
    enhance: '|信念的研磨石|信念的研磨石',
    box: '|生命的BOSS戒指箱子,混沌的漆黑飾品箱|生命的BOSS戒指箱子,混沌的漆黑飾品箱',
    focus: '|扭曲的渴望碎片|傲慢的原罪,渴望的永恆防具箱,扭曲的渴望碎片',
    ELTA: '|450|750',
    determination: '|a 160|a 500',
    soul: '|1200|3500',
    erion: '|45|360',
    traces: '|210|630',
    mystery: '|1800|2000',
    crystallization: '|w 7.5億|w 13.68億',
  },
  {
    img: 'Baldrix',
    name: '巴德利斯',
    hard: '劇情\n任務|普通|困難',
    level: '290|290|290',
    health: '3.15兆|2379兆>2531兆>3382兆|5340兆>5688兆>7600兆',
    defense: '300|380|380',
    ARCAUT: 'AUT 600|AUT 700|AUT 700',
    timeout: '30|30|30',
    death: '腐蝕1000|腐蝕1000|腐蝕1000',
    other: '|巴德利斯機器人|巴德利斯機器人',
    furnishing: '|藍色魔力壁爐|藍色魔力壁爐',
    enhance: '|信念的研磨石|信念的研磨石',
    box: '|生命的BOSS戒指箱子,混沌的漆黑飾品箱|生命的BOSS戒指箱子,混沌的漆黑飾品箱',
    focus: '|永恆忠誠的痕跡|死亡之誓,誓言的永恆防具箱,永恆忠誠的痕跡',
    ELTA: '|450|650',
    determination: '|a 150|a 450',
    soul: '|800|2400',
    erion: '||120',
    traces: '|80|240',
    mystery: '|1750|1950',
    crystallization: '|w 5.6億|w 8.4億',
  },
  {
    img: 'Limbo',
    name: '林波',
    hard: '劇情\n任務|普通|困難',
    level: '285|285|285',
    health: '1.43兆×4|970.8兆×4>2588.8兆|1887兆×4>4884兆',
    defense: '300|380|380',
    ARCAUT: 'AUT 400|AUT 500|AUT 500',
    timeout: '30|30|30',
    death: '侵蝕1000|侵蝕1000|侵蝕1000',
    other: '|林波洛伊德|林波洛伊德',
    furnishing: '|深淵窗戶|深淵窗戶',
    enhance: '|信念的研磨石|信念的研磨石',
    box: '|生命的BOSS戒指箱子,混沌的漆黑飾品箱|生命的BOSS戒指箱子,混沌的漆黑飾品箱',
    focus: '|扭曲的欲望結晶|根源的耳語,欲望的永恆防具箱,扭曲的欲望結晶',
    ELTA: '|350|550',
    determination: '|a 120|a 360',
    soul: '|600|1400',
    erion: '||60',
    traces: '|80|240',
    mystery: '|1700|1850',
    crystallization: '|w 4.2億|w 7.49億',
  },
  {
    img: 'BrilliantDarkness',
    name: '燦爛的凶星',
    hard: '劇情\n任務|普通|困難',
    level: '280|280|280',
    health: '5.25兆|3288.4兆|1.474京',
    defense: '380|380|380',
    ARCAUT: 'AUT 400|AUT 400|AUT 550',
    timeout: '30|30|30',
    death: '補食1000|補食1000|補食1000',
    other: '|凶星機器人|凶星機器人',
    enhance: '|生命研磨石|信念的研磨石',
    box: '|白玉的BOSS戒指箱子,混沌的漆黑飾品箱|生命的BOSS戒指箱子,混沌的漆黑飾品箱',
    focus: '|恍惚幻象碎片|恍惚的惡夢,幻想的永恆防具箱,恍惚幻象的斷片',
    ELTA: '|380|550',
    determination: '|a 20|a 380',
    soul: '|480|1500',
    erion: '||90',
    traces: '|60|240',
    mystery: '|1700|1850',
    crystallization: '|w 3.5532億|w 8.1751億',
  },
  {
    img: 'Kaling',
    name: '咖凌',
    hard: '劇情\n任務|簡單|普通|困難|終極',
    level: '275|275|285|285|285',
    health: '1.575兆+1.68兆>1.722兆|96.6兆×3>105兆>93.24兆×3+108.8兆|399兆×3>468兆>399.36兆×3+462.08兆|920兆×3>1404兆>1406.8兆×3+1883.4兆|6018兆×3>6930兆>5197.5兆×3+6496.5兆',
    defense: '300|380|380|380|380',
    ARCAUT: 'AUT 230|AUT 230|AUT 330|AUT 350|AUT 480',
    timeout: '30|30|30|30|30',
    death: '||||',
    other: '||咖凌機器人|咖凌機器人|咖凌機器人',
    furnishing: '||咖凌頂篷床|咖凌頂篷床|咖凌頂篷床',
    enhance: '||生命研磨石|信念的研磨石|卓越鐵鎚(耳環),信念的研磨石',
    box: '|白玉的BOSS戒指箱子|白玉的BOSS戒指箱子,混沌的漆黑飾品箱|生命的BOSS戒指箱子,混沌的漆黑飾品箱|生命的BOSS戒指箱子,混沌的漆黑飾品箱',
    focus: '|交織的凶獸之環碎片|交織的凶獸之環碎片|交織的凶獸之環,殺手的永恆防具箱|交織的凶獸之環,殺手的永恆防具箱,玲瓏月光藥水',
    ELTA: '|200|300|500|800',
    determination: '||a 20|a 160|a 1200',
    soul: '|300|500|900|3000',
    erion: '|||60|480',
    traces: '|20|80|240|1440',
    mystery: '|1550|1700|1800|2000',
    crystallization: '|w 2.583億|w 3.617億|w 7.211億|w 14.433億',
  },
  {
    img: 'TheFirstAdversary',
    name: '最初的敵對者',
    hard: '劇情\n任務|簡單|普通|困難|終極',
    level: '270|270|280|285|290',
    health: '2.1兆|171兆×2+228兆|495兆×2+660兆|3135兆×2+4180兆|9655兆×2+1.287京',
    defense: '300|380|380|380|380',
    ARCAUT: 'AUT 200|AUT 220|AUT 320|AUT 340|AUT 460',
    timeout: '30|30|30|30|30',
    death: '|意志1000|意志1000|意志1000|意志1000',
    other: '||敵對者機器人|敵對者機器人|敵對者機器人',
    enhance: '||生命研磨石|生命研磨石|卓越鐵鎚(勳章),生命研磨石',
    box: '|白玉的BOSS戒指箱子|白玉的BOSS戒指箱子|生命的BOSS戒指箱子|生命的BOSS戒指箱子',
    focus: '||世代傳承的遠古決心碎片|不朽的遺產,遠古永恆防具箱,世代傳承的遠古決心|不朽的遺產,遠古永恆防具箱,世代傳承的遠古決心,玲瓏月光藥水',
    ELTA: '|200|280|450|750',
    determination: '||a 20|a 120|a 500',
    soul: '|200|350|1000|2800',
    erion: '|||30|240',
    traces: '|10|40|180|540',
    mystery: '|1500|1600|1800|1950',
    crystallization: '|w 2.527億|w 3.71億|w 6.82億|w 13.44億',
  },
  {
    img: 'Kalos',
    name: '監視者卡洛斯',
    hard: '劇情\n任務|簡單|普通|混沌|終極',
    level: '270|270|275>280|285|285',
    health: '1.5兆|94.5兆>262.5兆|336兆>720兆|1066兆>4016兆|5798兆>1.5498京',
    defense: '300|330|330>380|380|380',
    ARCAUT: 'AUT 70|AUT 200|AUT\n⑴ 250\n⑵ 300|AUT 330|AUT 440',
    timeout: '30|30|30|30|30',
    death: '5|5|5|5|5',
    other: '||尼基機器人|尼基機器人|尼基機器人',
    furnishing: '||卡洛斯吊扇|卡洛斯吊扇|卡洛斯吊扇',
    enhance: '||生命研磨石|生命研磨石|卓越鐵鎚(眼飾),生命研磨石',
    box: '|白玉的BOSS戒指箱子|白玉的BOSS戒指箱子|生命的BOSS戒指箱子|生命的BOSS戒指箱子',
    focus: '||遺留的卡洛斯的意志碎片|遺留的卡洛斯意志|遺留的卡洛斯意志,意志的永恆防具箱,玲瓏月光藥水',
    ELTA: '|200|250|400|700',
    determination: '||a 10|a 70|a 400',
    soul: '|180|325|550|2600',
    erion: '||||180',
    traces: '|6|30|100|500',
    mystery: '|1500|1600|1750|1900',
    crystallization: '|w 2.369億|w 3.9億|w 6.188億|w 12.371億',
  },
  {
    img: 'Seren',
    name: '受選的賽蓮',
    hard: '普通|困難|終極',
    level: '270|275|280',
    health: '52.5兆>155.4兆|126兆>357兆|1309兆>5160兆',
    defense: '380|380|380',
    ARCAUT: 'AUT\n⑴ 150\n⑵ 200|AUT\n⑴ 150\n⑵ 200|AUT\n⑴ 150\n⑵ 200',
    timeout: '30|30|30',
    death: '5|5|5',
    other: '||',
    furnishing: '|聖劍壁掛裝飾|聖劍壁掛裝飾',
    enhance: '||卓越鐵鎚(臉部裝飾)',
    box: '黑玉的BOSS戒指箱子|白玉的BOSS戒指箱子|白玉的BOSS戒指箱子',
    focus: '破曉墜飾|米特拉的憤怒選擇箱,破曉墜飾,米特拉的核心寶石|米特拉的憤怒選擇箱,破曉墜飾,米特拉的核心寶石,玲瓏月光藥水',
    ELTA: '150|220|560',
    determination: '|a 6|a 80',
    soul: '160|250|750',
    erion: '||30',
    traces: '6|15|180',
    mystery: '1400|1500|1850',
    crystallization: 'w 1.498億|w 2.716億|w 7.242億',
  },
  {
    img: 'BlackMage',
    name: '黑魔法師',
    hard: '劇情\n任務|困難|終極',
    level: '250|265>275>275>265|275>275>275>280',
    health: '84億>126億>168億>105億|63兆>115.5兆>157.5兆>136.5兆|1180兆>1191兆>1285兆>1155兆',
    defense: '30|300|300',
    ARCAUT: 'ARC 880|ARC 1320|ARC 1320',
    timeout: '60|60|30',
    death: '12|12|12',
    other: '||',
    furnishing: '|黑魔法師的鏡子|黑魔法師的鏡子',
    enhance: '||卓越鐵鎚(腰帶)',
    box: '|白玉的BOSS戒指箱子|白玉的BOSS戒指箱子',
    focus: '|創世的胸章,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱|創世的胸章,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱',
    ELTA: '|300|600',
    determination: '|t 600|t 600',
    crystallization: '|m 9億9084萬1916|m 30億',
  },
  {
    img: 'Djunkel',
    name: '頓凱爾',
    hard: '劇情\n任務|普通|困難',
    level: '265|265|265',
    health: '210億|26兆|157.5兆',
    defense: '50|300|300',
    ARCAUT: '|ARC 850|ARC 850',
    timeout: '30|30|30',
    death: '5|5|5',
    furnishing: '||頓凱爾的頭盔裝飾',
    box: '|綠玉的BOSS戒指箱子|黑玉的BOSS戒指箱子',
    focus: '|星耀耳環|指揮官力量耳環,星耀耳環,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱',
    ELTA: '||120',
    determination: '|t 25|t 75',
    soul: '|40|95',
    mystery: '|900|1300',
    crystallization: '|w 8470萬|w 1億2620萬',
  },
  {
    img: 'Malitia',
    name: '瑪麗西亞',
    hard: '普通|終極',
    level: '250|250',
    health: '49兆+21兆>56兆>24兆(砲5下)>28兆|1.4308京+6132兆>2.128京>10.8京>1.28京',
    defense: '380>300>300>300|380>300>300>300',
    timeout: '30|30',
    death: '5|5',
    other: '|瑪麗西亞機器人',
    furnishing: '|紅月坐墊',
    enhance: '月之淚,神聖月亮精華|月亮的意志,月之淚,神聖月亮精華,信念的研磨石',
    box: '黑玉的BOSS戒指箱子|生命的BOSS戒指箱子',
    focus: '閃耀的龍鱗片,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱|閃耀的龍鱗片,惡意永恆防具箱,石像瑪麗西亞裝飾設計圖',  // 瑪麗西亞靈魂寶珠
    ELTA: '120|1000',
    soul: '170|5000',
    crystallization: 'w 1.5億|w 15億',
  },
  {
    img: 'Hilla(Real)',
    name: '真希拉',
    hard: '劇情\n任務|創世\n任務|普通|困難',
    level: '210|250|250|250',
    health: '280億|132兆|88兆|176兆',
    defense: '30|300|300|300',
    ARCAUT: '|ARC 900|ARC 900|ARC 900',
    timeout: '30|30|30|30',
    death: '5|5|5|5',
    furnishing: '|靈魂燃燒的蠟燭||靈魂燃燒的蠟燭',
    box: '||紅玉的BOSS戒指箱子|黑玉的BOSS戒指箱子',
    focus: '|苦痛的根源,破曉墜飾,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱|破曉墜飾|苦痛的根源,破曉墜飾,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱',
    ELTA: '||70|100',
    determination: '||t 45|t 90',
    soul: '||70|100',
    mystery: '||1200|1350',
    crystallization: '|1億4520萬|w 1億2440萬|w 1億4520萬',
  },
  {
    img: 'Dusk',
    name: '戴斯克',
    hard: '劇情\n任務|普通|混沌',
    level: '255|255|255',
    health: '210億|25.5兆|127.5兆',
    defense: '30|300|300',
    ARCAUT: 'ARC 730|ARC 730|ARC 730',
    timeout: '30|30|30',
    death: '5|5|5',
    furnishing: '||戴斯克黑暗懶骨頭',
    box: '|綠玉的BOSS戒指箱子|黑玉的BOSS戒指箱子',
    focus: '|星耀耳環|巨大的恐怖,星耀耳環,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱',
    ELTA: '||100',
    determination: '|t 20|t 65',
    soul: '|40|90',
    mystery: '|900|1250',
    crystallization: '|w 7950萬|w 1億1120萬',
  },
  {
    img: 'Will',
    name: '威爾',
    hard: '劇情\n任務|簡單|普通|困難',
    level: '235|235|235|235',
    health: '84億>63億>63億|2.8兆+2.8兆>4.2兆>7兆|4.2兆+4.2兆>6.3兆>10.5兆|21兆+21兆>31.5兆>52.5兆',
    defense: '30|300|300|300',
    ARCAUT: '|ARC 560|ARC 760|ARC 760',
    timeout: '30|30|30|30',
    death: '10|10|10|10',
    furnishing: '|||威爾的蜘蛛網狀吊椅',
    box: '|綠玉的BOSS戒指箱子|綠玉的BOSS戒指箱子|紅玉的BOSS戒指箱子',
    focus: '||克伯威水滴石,暮光印記|受詛咒的魔導書選擇箱,克伯威水滴石,暮光印記,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱,鏡子世界的核心寶石',
    ELTA: '|||50',
    determination: '|t 15|t 25|t 75',
    soul: '|10|35|80',
    mystery: '|700|800|1200',
    crystallization: '|w 5740萬|w 7420萬|w 1億2740萬',
  },
  {
    img: 'Lucid',
    name: '露希妲',
    hard: '劇情\n任務|簡單|普通|困難',
    level: '230|230|230|230',
    health: '147億>63億|6兆>6兆|12兆>12兆|50.8兆>54兆>12.8079兆',
    defense: '30|300|300|300',
    ARCAUT: 'ARC 250|ARC 360|ARC 360|ARC 360',
    timeout: '30|30|30|30',
    death: '10|10|10|10',
    other: '|||露希妲機器人',
    furnishing: '|||露希妲床鋪',
    box: '|綠玉的BOSS戒指箱子|綠玉的BOSS戒指箱子|紅玉的BOSS戒指箱子',
    focus: '||蝴蝶翅膀水滴石,暮光印記|夢幻的腰帶,蝴蝶翅膀水滴石,暮光印記,神秘冥界幽靈武器箱,神秘冥界幽靈防具箱',
    ELTA: '|||50',
    determination: '|t 15|t 20|t 65',
    soul: '|10|35|80',
    mystery: '|700|800|1200',
    crystallization: '|w 5380萬|w 6430萬|w 1億240萬',
  },
  {
    img: 'DivineKingSlime',
    name: '守護天使綠水靈',
    hard: '普通|混沌',
    level: '220|220',
    health: '5兆|115.5兆',
    defense: '300|300',
    timeout: '30|30',
    death: '5|5',
    furnishing: '|守護天使綠水靈噴泉',
    box: '綠玉的BOSS戒指箱子|黑玉的BOSS戒指箱子',
    focus: '守護者天使戒指|守護者天使戒指',
    ELTA: '|70',
    soul: '10|90',
    mystery: '600|1250',
    crystallization: 'w 4300萬|w 1億2650萬',
  },
  {
    img: 'Damien',
    name: '戴米安',
    hard: '劇情\n任務|普通|困難',
    level: '150|210|210',
    health: '4.9億>2.1億|8400億>3600億|25.2兆>10.8兆',
    defense: '|300|300',
    timeout: '30|30|30',
    death: '10|10|10',
    other: '||戴米安機器人',
    furnishing: '||戴米安的劍',
    box: '|綠玉的BOSS戒指箱子|紅玉的BOSS戒指箱子',
    focus: '|毀滅力量盾牌,扭曲烙印的靈魂石|附有魔力的眼罩,毀滅力量盾牌,扭曲烙印的靈魂石,航海師武器箱,航海師防具箱',
    ELTA: '||50',
    determination: '|t 10|t 50',
    soul: '|10|50',
    mystery: '|500|1000',
    crystallization: '|w 2884萬3452|w 8570萬',
  },
  {
    img: 'Lotus',
    name: '史烏',
    hard: '劇情\n任務|普通|困難|終極',
    level: '玩家等級|210|210|285',
    health: '15億>25億>35億|4700億>4700億>6300億|10兆>10兆>13.5兆|545兆>545兆>720兆',
    defense: '30|300|300|380',
    timeout: '30|30|30|30',
    death: '5|5|5|5',
    other: '||史烏機器人|殲滅兵器史烏機器人',
    furnishing: '||殺人鯨兔子娃娃抱枕|',
    box: '|綠玉的BOSS戒指箱子|紅玉的BOSS戒指箱子|白玉的BOSS戒指箱子',
    focus: '|特殊能量硬幣(S級)|口紅控制器標誌,特殊能量硬幣(S級),航海師武器箱,航海師防具箱|全面控制核心,口紅控制器標誌',  // 受損的黑心臟
    ELTA: '||50|',
    determination: '|t 10|t 50|t 50',
    soul: '|10|45|450',
    mystery: '|500|1000|1650',
    crystallization: '|w 2720萬7040|w 9190萬|w 3億2350萬',
  },
  {
    img: 'Cygnus',
    name: '西格諾斯',
    hard: '簡單|普通',
    level: '140|190',
    health: '105億|630億',
    defense: '100|100',
    timeout: '30|30',
    death: '5|5',
    furnishing: '|西格諾斯娃娃置物架',
    focus: '黑色破壞的碎片,黑色守護的碎片|黑色破壞的碎片,黑色守護的碎片,女皇系列肩膀',
    soul: '|10',
    mystery: '10|50',
    crystallization: 'w 530萬7400|w 870萬9400',
  },
  {
    img: 'PinkBean',
    name: '粉豆',
    hard: '普通|混沌',
    level: '180|190',
    health: '21億|693億',
    defense: '70|180',
    timeout: '30|30',
    death: '5|5',
    furnishing: '|粉豆沙發',
    focus: '黑豆標記,金花草腰帶,粉紅聖杯|黑豆標記,金花草腰帶,粉紅聖杯',
    mystery: '|50',
    crystallization: 'd 81萬3700|w 763萬0700',
  },
  /* {
    img: 'Gollux',
    name: '培羅德',
    hard: '初級|中級|高級|頂級',
    level: '170|180|190|200',
    health: '5000萬>5000萬>1000萬|30億>30億>6億|750億>750億>150億|3500億>3500億>700億',
    defense: '10|15|150|250',
    timeout: '30|30|30|30',
    death: '5|5|5|5',
    other: '|||真正守護者的終章',
    furnishing: '|||培羅德長木椅',
    focus: '||培羅德硬幣|培羅德硬幣,頂級培羅德耳環,頂級培羅德烙印腰帶',
    crystallization: '|||',
  }, */
  {
    img: 'PrincessNou',
    name: '濃姬',
    hard: '普通',
    level: '160',
    health: '5000億',
    defense: '100',
    timeout: '60',
    death: '20',
    other: '濃姬特效交換券,妖蝶姬之座椅,濃姬傷害字型',
    focus: '魅惑的碎片',
    mystery: '400',
    crystallization: 'w 895萬3200',
  },
  {
    img: 'Arkarium',
    name: '阿卡伊農',
    hard: '簡單|普通',
    level: '130|170',
    health: '21億|126億',
    defense: '60|90',
    timeout: '30|30',
    death: '5|5',
    furnishing: '|阿卡伊農石像',
    focus: '梅克奈特墜飾|支配者墜飾,梅克奈特墜飾',
    crystallization: 'd 66萬7400|d 146萬0300',
  },
  {
    img: 'Horntail',
    name: '暗黑龍王',
    hard: '簡單|普通|混沌',
    level: '130|160|160',
    health: '1億>1億>8.176億|3.3億>3.3億>20.9億|33億>33億>200億',
    defense: '40|40|50',
    timeout: '30|30|30',
    death: '10|5|5',
    furnishing: '||闇黑龍王噴泉',
    focus: '銀花戒指,戴雅希杜斯耳環|闇黑龍王項鍊,銀花戒指,戴雅希杜斯耳環|混沌闇黑龍王的項鍊,銀花戒指,戴雅希杜斯耳環',
    crystallization: 'd 51萬1000|d 58萬6600|d 78萬3300',
  },
  {
    img: 'VonLeon',
    name: '凡雷恩',
    hard: '簡單|普通|困難',
    level: '120|120|120',
    health: '7億|63億|105億',
    defense: '50|80|90',
    timeout: '30|30|30',
    death: '5|5|5',
    furnishing: '||凍結的獅子雕像',
    focus: '||伊菲亞的項鍊,伊菲亞的戒指,伊菲亞的耳環',
    crystallization: 'd 61萬2900|d 84萬4700|d 141萬9500',
  },
  {
    img: 'Vellum',
    name: '貝倫',
    hard: '普通|混沌',
    level: '130|190',
    health: '5.5億|2000億',
    defense: '55|200',
    timeout: '15|20',
    death: '5|5',
    other: '奇岩礦石之椅|奇岩礦石之椅',
    furnishing: '|貝倫熔岩浴缸',
    focus: '|破滅的碎片,混沌貝倫的頭盔',
    soul: '|10',
    mystery: '|300',
    crystallization: 'd 56萬0800|w 907萬0003',
  },
  {
    img: 'BloodyQueen',
    name: '血腥皇后',
    hard: '普通|混沌',
    level: '120|190',
    health: '3.15億|1400億',
    defense: '50|120',
    timeout: '15|20',
    death: '5|5',
    other: '怕怕皇后|怕怕皇后',
    furnishing: '|血腥皇后梳妝台',
    focus: '|吶喊的碎片,混沌皇后的皇冠',
    soul: '|10',
    mystery: '|200',
    crystallization: 'd 56萬0800|w 768萬2035',
  },
  {
    img: 'VonBon',
    name: '斑斑',
    hard: '普通|混沌',
    level: '120|190',
    health: '3.15億|1000億+8億',
    defense: '50|100',
    timeout: '8|10',
    death: '5|5',
    other: '與斑斑一起|與斑斑一起',
    furnishing: '|斑斑的發條鐘',
    focus: '|時間碎片,混沌斑斑頭盔',
    soul: '|10',
    mystery: '|200',
    crystallization: 'd 56萬0800|w 769萬3781',
  },
  {
    img: 'Pierre',
    name: '比艾樂',
    hard: '普通|混沌',
    level: '120|190',
    health: '3.15億|800億',
    defense: '50|80',
    timeout: '15|20',
    death: '5|5',
    other: '開心的比艾樂|開心的比艾樂',
    furnishing: '|比艾樂傘架',
    focus: '|嘲弄的碎片,混沌比艾樂帽',
    soul: '|10',
    mystery: '|200',
    crystallization: 'd 56萬0800|w 731萬3306',
  },
  {
    img: 'Papulatus',
    name: '拉圖斯',
    hard: '簡單|普通|混沌',
    level: '125|155|190',
    health: '3億>1億|124.5億>41.5億|3780億>1260億',
    defense: '50|90|250',
    timeout: '30|30|30',
    death: '50|5|5',
    other: '|拉圖斯的時間椅子|拉圖斯的時間椅子',
    furnishing: '||拉圖斯壁鐘',
    focus: '||拉圖斯標誌',
    soul: '||10',
    mystery: '||400',
    crystallization: 'd 39萬6500|d 154萬3700|w 2008萬8150',
  },
  {
    img: 'Kawoong',
    name: '卡翁',
    hard: '普通',
    level: '180',
    health: '16.8億',
    defense: '60',
    timeout: '30',
    death: '5',
    furnishing: '卡翁吸塵器',
    crystallization: 'd 72萬4200',
  },
  {
    img: 'MoriRanmaru',
    name: '森蘭丸',
    hard: '普通|困難',
    level: '120|180',
    health: '10億|105億',
    defense: '55|55',
    timeout: '60|60',
    death: '無限|無限',
    crystallization: 'd 37萬5500|d 154萬3700',
  },
  {
    img: 'Hilla',
    name: '希拉',
    hard: '普通|困難',
    level: '85|170',
    health: '5億|168億',
    defense: '50|100',
    timeout: '30|30',
    death: '無限|15',
    other: '[寵物箱子] 暗黑之魂|[寵物箱子] 暗黑之魂',
    furnishing: '|希拉方尖碑造型立燈',
    focus: '永生之石|永生之石,地獄火耳環',
    mystery: '|50',
    crystallization: 'd 46萬3500|w 667萬7700',
  },
  {
    img: 'Magnus',
    name: '梅格耐斯',
    hard: '簡單|普通|困難',
    level: '115|155|175',
    health: '4億|60億|1200億',
    defense: '50|50|120',
    timeout: '30|30|30',
    death: '5|10|15',
    furnishing: '||梅格耐斯尖角椅子',
    focus: '皇家暗黑合金護肩,水晶溫杜斯胸章|皇家暗黑合金護肩,水晶溫杜斯胸章|被詛咒的凱撒利恩,皇家暗黑合金護肩,水晶溫杜斯胸章',
    soul: '||10',
    mystery: '||300',
    crystallization: 'd 41萬8300|d 150萬1700|w 881萬9007',
  },
  {
    img: 'Zakum',
    name: '殘暴炎魔',
    hard: '簡單|普通|混沌',
    level: '50|90|90',
    health: '220萬+20.4萬|700萬+70萬|840億+105億',
    defense: '30|40|100',
    timeout: '20|30|30',
    death: '50|5|5',
    furnishing: '||炎魔之手桌子',
    focus: '凝聚力量的結晶石,水中信紙眼飾|凝聚力量的結晶石,水中信紙眼飾|憤怒的殘暴炎魔的腰帶,凝聚力量的結晶石,水中信紙眼飾',
    soul: '||10',
    mystery: '||200',
    crystallization: 'd 11萬5800|d 35萬4800|w 705萬9750',
  },
  {
    img: 'Balrog',
    name: '巴洛古',
    hard: '簡單',
    level: '65',
    health: '478萬7520',
    defense: '25',
    timeout: '20',
    death: '5',
    furnishing: '巴洛古尖角椅子',
    crystallization: '',
  },
  /*{
    img: 'Urus',
    name: '烏勒斯',
    hard: '普通',
    level: '130',
    health: '2兆6252億2362萬4000',
    defense: '10',
    timeout: '10',
    death: '1',
    furnishing: '烏勒斯生命的樹木盆栽',
    crystallization: '',
  },*/
  {
    img: 'Dorothy',
    name: '桃樂絲',
    hard: '副本',
    level: '210',
    health: '8400億',
    defense: '250',
    timeout: '',
    death: '個人\n30次',
    other: '桃樂絲的傷害字型',
    furnishing: '琉德的劍',
    focus: '變質的愛麗西亞的長杖,光芒追求者,水瓶座冠,琉德的劍',
    crystallization: '',
  },
  {
    img: 'Seruf',
    name: '火蚌殼',
    hard: '地圖',
    level: '82',
    health: '145萬',
    defense: '',
    timeout: '',
    death: '',
    furnishing: '火蚌殼的貝殼床',
    crystallization: '',
  },
  {
    img: 'Tengu',
    name: '天狗',
    hard: '副本',
    level: '',
    health: '',
    defense: '',
    timeout: '',
    death: '',
    furnishing: '天狗的羽毛捕夢網',
    crystallization: '',
  },
  {
    img: 'Dyle',
    name: '沼澤巨鱷',
    hard: '地圖',
    level: '50',
    health: '30萬',
    defense: '',
    timeout: '',
    death: '',
    furnishing: '沼澤巨鱷的桌遊桌子',
    crystallization: '',
  },
  {
    img: 'Bigfoot',
    name: '終極怪物公園',
    hard: '副本',
    level: '260',
    health: '15兆',
    defense: '300',
    timeout: '20',
    death: '1',
    crystallization: '',
  },
];

export default function boss(state = bosses, action) {
    return state;
}
